import { render } from "./assetstable.vue?vue&type=template&id=54ab0328"
import script from "./assetstable.vue?vue&type=script&lang=js"
export * from "./assetstable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__